var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useRef, useState, useEffect } from 'react';
// Return explicit height (in pixels) of an element
// Required for smooth exit animation, since it is not possible to animate from auto height in CSS
function useHeight(targetRef) {
    var animateTimer = useRef();
    var _a = __read(useState('auto'), 2), height = _a[0], setHeight = _a[1];
    useEffect(function () {
        var element = targetRef.current;
        if (element) {
            cancelAnimationFrame(Number(animateTimer.current));
            animateTimer.current = requestAnimationFrame(function () {
                setHeight("".concat(element.clientHeight, "px"));
            });
        }
        return function () {
            cancelAnimationFrame(Number(animateTimer.current));
        };
    }, [targetRef]);
    return height;
}
export default useHeight;
